// extracted by mini-css-extract-plugin
export default {"addToCartControl":"e2-z","giftCard":"f2-z","btnContainer":"g2-z","cartButton":"h2-z","disabled":"i2-z"};